exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-button {\n  float: left;\n  clear: both;\n  background-color: #2CC185;\n  margin-right: 1em;\n  padding: .65em 1em;\n  color: white;\n  text-decoration: none;\n  border: 0;\n  cursor: pointer; }\n  .form-button:disabled {\n    background: #cfcfcf;\n    cursor: default; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/FormButtonComponent/formButton.component.scss
// module id = ./src/app/common/components/FormButtonComponent/formButton.component.scss
// module chunks = main